import { initialState, BP_Status } from '../state';
import { BpmnXmlActions, BpmnXmlActionTypes } from '../actions';


export function bpmnXmlParsingStatus(state = initialState.bpmnXmlParsingStatus, action: BpmnXmlActions): BP_Status {
  switch (action.type) {
    case BpmnXmlActionTypes.MARK_BPMN_XML_PARSING_COMPLETED: {
      return BP_Status.Completed;
    }
    case BpmnXmlActionTypes.MARK_BPMN_XML_PARSING_IN_PROGRESS: {
      return BP_Status.InProgress;
    }
    default: {
      return state;
    }
  }
}
